import styled from "styled-components";

export const SobrePageStyle = styled.div`
    
`